import clsx from 'clsx';

import { EditPenIcon } from '@/resources';

type SelectableCardProps = {
  isSelected: boolean;
  onSelect: () => void;
  label: string;
  imageUrl: string;
  isEditable?: boolean;
  onEdit?: () => void;
};

export const SelectableCard = ({
  isSelected,
  imageUrl,
  label,
  onSelect,
  isEditable,
  onEdit
}: SelectableCardProps) => {
  return (
    <div
      onClick={() => onSelect()}
      className='group relative flex cursor-pointer flex-col items-center gap-2'>
      <div className='absolute right-1 top-1 z-10 rounded-full bg-white p-3 outline outline-1 outline-secondary-steel-blue' />

      {isEditable && (
        <div
          className='absolute left-1 top-1 z-10 rounded-md bg-white/[.6] p-1 opacity-0 outline outline-1 outline-secondary-steel-blue transition-opacity duration-200 group-hover:opacity-100 hover:bg-primary-white'
          onClick={(event) => {
            event.stopPropagation();
            onEdit?.();
          }}>
          <EditPenIcon className='text-primary-blue' />
        </div>
      )}
      <div
        className={clsx(
          'absolute right-2.5 top-2.5 z-10 rounded-full bg-primary-blue p-1.5 transition-all duration-300',
          isSelected ? 'scale-100' : 'scale-0'
        )}
      />
      <div className='aspect-square w-full overflow-hidden rounded-md'>
        <img
          draggable={false}
          src={imageUrl}
          className='size-full object-cover transition-all duration-300 group-hover:scale-125'
        />
      </div>
      <div className='line-clamp-1 w-full truncate'>{label}</div>
    </div>
  );
};
